import { getAnalyticsItemCategoriesByTaxonomy } from './getAnalyticsItemCategoriesByTaxonomy';
import { ProductSearchMaterial } from '../../types/material';

export const handleRequestQuoteCTAClick = (
  product: ProductSearchMaterial,
  projectId: string | null,
  projectName: string | null,
) => {
  dataLayer.push({
    event: 'digital_sampling_request_a_quote_cta_click',
    location: 'digital_sampling',
    event_location: 'Quick View',
    event_project_name: projectName || undefined,
    event_project_id: projectId || undefined,
    event_item_id: product?.sku,
    event_item_name: product?.name,
    event_item_brand: product?.manufacturer,
    event_item_type: 'digital',
    ...getAnalyticsItemCategoriesByTaxonomy(product?.taxonomy, 'event_'),
    event_item_variant: product?.name,
    event_item_list_id: 'digital_sampling_mini_pdp',
    event_item_list_name: 'Digital Sampling Mini PDP',
  });
};
